export const POST_SUBMITTED = "POST-SUBMITTED";
export const POST_DELETED = "POST-DELETED";
export const POST_REPORTED = "POST-REPORTED";
export const LATEST_COMMENT_DELETED = "LATEST-COMMENT-DELETED";
export const LATEST_COMMENT_REPORTED = "LATEST-COMMENT-REPORTED";
export const OPEN_PRESENTER = "open-presenter-event";
export const OPEN_POST_DETAILS_MODAL = "open-post-details-modal-event";
export const POST_DETAILS_CHANGED = "post-details-changed";
export const POST_OPTIONS_CLICK = "post-options-click";
export const POLL_RESPONSE_SUBMITTED = "poll-response-submitted";
export const POLL_RESPONSE_SUBMIT_ERROR = "poll-response-submit-error";
